import { Component, Input, OnInit } from '@angular/core';
import { IDeploySupplierContext } from '../../interfaces/deploy-supplier-context';

@Component({
  selector: 'deploy-supplier-card',
  styleUrls: ['./deploy-supplier-card.component.scss'],
  templateUrl: './deploy-supplier-card.component.html',
})
export class DeploySupplierCardComponent implements OnInit {
  @Input() deploySupplierContext: IDeploySupplierContext;

  ngOnInit(): void {}
}
